export default [
  {
    path: '/school',
    name: 'school',
    meta: {
      exp: '华转学堂',
      requireAuth: false
    },
    component: () => import('@/views/school/index.vue'),
  },
  {
    path: '/school_list',
    name: 'school_list',
    meta: {
      exp: '华转学堂-课程列表',
      requireAuth: false
    },
    component: () => import('@/views/school/course/list/index.vue'),
  },
  {
    path: '/school_detail',
    name: 'school_detail',
    meta: {
      exp: '华转学堂详情',
      requireAuth: false
    },
    component: () => import('@/views/school/course/detail/index.vue'),
  },
  {
    path: '/school_exam',
    name: 'school_exam',
    meta: {
      exp: '华转学堂-课程小测',
      requireAuth: false
    },
    component: () => import('@/views/school/exam/index.vue'),
  },
  {
    path: '/teacher',
    name: 'teacher',
    meta: {
      exp: '华转学堂-老师列表',
      requireAuth: false
    },
    component: () => import('@/views/school/teacher/list/index.vue'),
  },
  {
    path: '/teacher_detail',
    name: 'teacher_detail',
    meta: {
      exp: '华转学堂-老师详情',
      requireAuth: false
    },
    component: () => import('@/views/school/teacher/detail/index.vue'),
  },
  // {
  //   path: '/personal_cneter/hz_school',
  //   name: 'personal_cneter_hz_school',
  //   meta: {
  //     exp: '华转学堂-个人中心',
  //     requireAuth: true
  //   },
  //   redirect:'/personal_cneter/hz_school/course',
  //   component: () => import('@/views/personal_center/HZ_school/index.vue')
  // },
  // {
  //   path: '/personal_cneter/hz_school/course',
  //   name: 'personal_cneter_hz_school_course',
  //   meta: {
  //     exp: '华转学堂-我的课程',
  //     requireAuth: true
  //   },
  //   component: () => import('@/views/personal_center/HZ_school/course/index.vue')
  // },
  // {
  //   path: '/personal_cneter/hz_school/certificate',
  //   name: 'personal_cneter_hz_school_certificate',
  //   meta: {
  //     exp: '华转学堂-我的证书',
  //     requireAuth: true
  //   },
  //   component: () => import('@/views/personal_center/HZ_school/certificate/index.vue')
  // },
  // {
  //   path: '/personal_cneter/hz_school/collection',
  //   name: 'personal_cneter_hz_school_collection',
  //   meta: {
  //     exp: '华转学堂-我的收藏',
  //     requireAuth: true
  //   },
  //   component: () => import('@/views/personal_center/HZ_school/collection/index.vue')
  // },
  // {
  //   path: '/personal_cneter/hz_school/order',
  //   name: 'personal_cneter_hz_school_order',
  //   meta: {
  //     exp: '华转学堂-我的订单',
  //     requireAuth: true
  //   },
  //   component: () => import('@/views/personal_center/HZ_school/order/index.vue')
  // },
]
